// extracted by mini-css-extract-plugin
export default {"removeStroke":"components-Shared-Icon-paymentMethods-styles__removeStroke--TqUAs"};